import script from "./Depository.vue?vue&type=script&lang=ts&setup=true"
export * from "./Depository.vue?vue&type=script&lang=ts&setup=true"

import "./Depository.vue?vue&type=style&index=0&id=abaeb5ee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abaeb5ee"]])

export default __exports__